<template>
  <div class="landing-page">
    <b-modal
      id="bv-modal-example"
      title="Подтвердите учетная запись"
      :header-bg-variant="'dark'"
      :header-text-variant="'light'"
      hide-footer
      v-model="reg">
      <div style="color: #424242">
        <span class="reg-text" v-if="type === 'Почта'">
          Мы отправили ссылку для активации аккаунта на почту - {{ email }}
        </span>
        <span class="reg-text" v-else>
          Мы отправили Вам смс для активации аккаунта
        </span>
      </div>
      <b-button block @click="$bvModal.hide('bv-modal-example')">Закрыть</b-button>
    </b-modal>
    <div class="section main-section">
      <div class="clip">
        <div class="left-block">
          <div class="logo-circle">
            <img :src="organization.logo" alt="">
          </div>
          <h1>{{ organization.title }}</h1>
          <p>{{ organization.info }}</p>
        </div>
        <div v-if="!isAuth" class="right-block">
          <form @submit.prevent="submit" class="form" :style="backgroundColor">
            <div v-if="loading" class="loading"></div>
            <h2>Подлючитесь к нам!</h2>
            <div class="fields">
              <div class="field">
                <input v-model="firstName" type="text" placeholder="Имя">
                <span class="error" v-if="errors.firstName">{{ errors.firstName }}</span>
              </div>
              <div class="field">
                <input v-model="lastName" type="text" placeholder="Фамилия">
                <span class="error" v-if="errors.lastName">{{ errors.lastName }}</span>
              </div>
              <div class="field field-username">
                <v-select
                  v-model="type"
                  :options="['Телефон', 'Почта']"
                  :clearable="false"
                  :searchable="false">
                  <template #open-indicator="{ attributes }">
                    <i v-bind="attributes" class="material-icons">keyboard_arrow_down</i>
                  </template>
                </v-select>
                <masked-input v-if="type === 'Телефон'"
                  type="text"
                  name="phone"
                  v-model="phone"
                  :mask="['+', '7', ' ', '(', /[1-9]/, /\d/, /\d/, ')', ' ', /\d/, /\d/, /\d/, '-', /\d/, /\d/, /\d/, /\d/]"
                  placeholder="+7 (900) 000-0000"
                  placeholderChar="#">
                </masked-input>
                <input v-else type="email" placeholder="example@mail.net" v-model="email">
                <span class="error" v-if="errors.login">{{ errors.login }}</span>
              </div>
              <div class="field">
                <input v-model="password" type="password" placeholder="Пароль">
                <span class="error" v-if="errors.password">{{ errors.password }}</span>
              </div>      
              <div class="field">
                <input v-model="confirmPassword" type="password" placeholder="Повтор пароля">
                <span class="error" v-if="errors.confirmPassword">{{ errors.confirmPassword }}</span>
              </div>
              <button :style="buttonBackgroundColor" type="submit">Зарегистироваться</button>
              <div class="subbutton">
                Есть аккаунт? <a class="link" :style="textColor" @click="openLoginDialod()">Вход</a>
              </div>
            </div>
          </form>
        </div>
        <div v-else class="welcome-block">
          <div class="welcome-box" :style="backgroundColor">
            <div class="title">
              Добро пожаловать,<br> {{ fullName }}
            </div>
            <router-link class="lk-button" :to="{ name: 'personal-area.main' }">Личный кабинет</router-link>
          </div>
        </div>
      </div>
    </div>
    <div class="section" v-if="isAuth">
      <div class="clip">
        <formDoc />
      </div>
    </div>
    <div v-if="organization.front.coords" class="section map-section">
      <yandex-map class="map"
        :coords="organization.front.coords"
        :controls="[]"
        :zoom="17">
        <ymap-marker 
          :coords="organization.front.coords"
          :icon="markerIcon"
          marker-id="123" 
          hint-content="Наша клиника!" 
        />
      </yandex-map>
      <div class="box">
        <div class="info" v-if="organization.address">
          <div class="info_title">Адрес</div>
          <div class="info_content">
            {{ organization.address }}
          </div>
        </div>
        <div class="info" v-if="organization.worktime">
          <div class="info_title">Время работы</div>
          <div class="info_content">
            {{ organization.worktime }}
          </div>
        </div>
        <div class="info" v-if="organization.phones">
          <div class="info_title">Телефон</div>
          <div class="info_content">
            {{ organization.phones }}
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import axios from 'axios';
import store from '@app/store';
import { yandexMap, ymapMarker } from 'vue-yandex-maps';
import MedicalIcon from '@app/assets/medical-pin.svg';
import { isEmpty } from 'lodash';
import MaskedInput from 'vue-text-mask';
import { theme } from '@app/theme';
import parse from 'parse-color';
import helper from '@app/services/helper';

import formDoc from '@app/views/appointment/form/Form';

export default {
  components: { formDoc, MaskedInput, yandexMap, ymapMarker },
  data: () => ({
    reg: false,
    loading: false,
    errors: {},
    settings: null,
    login: '',
    email: '',
    phone: '',
    firstName: '',
    lastName: '',
    type: 'Телефон',
    password: '',
    confirmPassword: '',
    markerIcon: {
      layout: 'default#imageWithContent',
      imageHref: MedicalIcon,
      imageSize: [64, 64],
      imageOffset: [-32, -64],
    },
    center: [
      59.937500,
      30.308611,
    ],
    coords: [
      59.937500,
      30.308611,
    ],
    ...theme
  }),
  async beforeRouteEnter({ name }, from, next) {
    await store.dispatch('clinic/preload', name);
    next();
  },
  async beforeRouteUpdate({ name }, from, next) {
    await store.dispatch('clinic/preload', name);
    next();
  },
  computed: {
    fullName() {
      return this.$store.state.permission.userName;
    },
    isAuth() {
      return this.$store.state.auth.is_auth;
    },
    organization() {
      return this.$store.state.clinic.organization.form;
    },
    textColor() {
      const { rgb } = parse(this.primaryColor);
      const offset = 50;
      const color = this.offsetColor(rgb, offset);
      return { color };
    },
    buttonBackgroundColor() {
      return { backgroundColor: this.primaryColor };
    },
    backgroundColor() {
      const { rgb } = parse(this.primaryColor);
      const offset = -50;
      const backgroundColor = this.offsetColor(rgb, offset);
      return { backgroundColor };
    }
  },
  methods: {
    openLoginDialod() {
      this.$store.commit('navigation/setLoginDialog', true);
    },
    offsetColor([red, green, blue], offset) {
      return `rgb(${this.clipColor(red, offset)}, ${this.clipColor(green, offset)}, ${this.clipColor(blue, offset)}, 0.9)`;
    },
    clipColor(color, diff) {
      const value = color + diff;
      return value > 0 ? value < 255 ? value : 255 : 0;
    },
    validate() {
      let errors = {};
      const required = 'Это поле обязательное';
      const login = this.type === 'Телефон' ? this.phone : this.email;
      if (login === '') {
        errors.login = required;
      }
      if (this.firstName === '') {
        errors.firstName = required;
      }
      if (this.lastName === '') {
        errors.lastName = required;
      }
      if (this.password === '') {
        errors.password = required;
      }
      if (this.confirmPassword === '') {
        errors.confirmPassword = required;
      }
      if ((this.password !== '' && this.confirmPassword !== '') &&
        this.password !== this.confirmPassword) {
        errors.password = 'Пароли не совпадают';
        errors.confirmPassword = 'Пароли не совпадают';
      }
      return errors;
    },
    async signIn(email, password) {
      const body = { email, password };
      const { data } = await axios.post('/login', body);
      localStorage.setItem('auth_token', data.token);
      axios.defaults.headers.common['Authorization'] = 'Bearer ' + data.token;
      await helper.check();
      await this.$store.dispatch('auth/setAuthStatus');
      await this.$store.dispatch('auth/setLastActivity');
    },
    async submit() {
      this.errors = this.validate();
      if (isEmpty(this.errors)) {
        this.loading = true;
        const email = this.type === 'Телефон' ? this.phone : this.email;
        const form = new Form({
          email,
          password: this.password,
          password_confirmation: this.password_confirmation,
          first_name: this.firstName,
          last_name: this.lastName,
          middle_name: '',
          tnc: false
        });
        try {
          const { message } = await form.post('/api/auth/register/');
          toastr.success(message);
          this.reg = true;
          await this.signIn(email, this.password);
        } catch(err) {
          // const errorMessage = Object.entries(errors)
          //   .reduce((acc, [key, value]) => [ ...acc, ...value ], [])
          //   .join(', ');
          helper.showErrorMsg(err);
        }
        this.loading = false;
      }
    }
  }
};
</script>
<style>
.landing-page .vs__dropdown-toggle {
  border: 0;
  padding: 0;
}
.landing-page .vs__selected {
  padding: 0;
  margin: 0;
}
.landing-page .vs__selected-options,
.landing-page .vs__search {
  padding: 0;
  margin: 0;
}
.landing-page .vs__dropdown-menu {
  background-color: #ffffff;
  border: none;
  color: #394066;
  text-transform: lowercase;
  font-variant: small-caps;
  min-width: 100px;
  top: calc(100% + 6px);
}
</style>

<style scoped>
h1 {
  color: #ffffff;
}
p {
  color: #ffffff;
  font-weight: 300;
}
.main-section {
  position: relative;
  background: url('~@/assets/landing-bg.jpg') no-repeat;
  background-size: cover;
  background-position: center;
}
.main-section:before {
  content: ' ';
  position: absolute;
  top: 0; bottom: 0; left: 0; right: 0;
  background-color: rgba(0, 0, 0, .4);
}
.main-section .clip {
  position: relative;
  z-index: 2;
  display: flex;
  justify-content: space-between;
  align-items: center; 
  height: 570px;
}
.main-section .right-block {
  width: 350px;
  flex: 0 0 350px;
}
.main-section .welcome-block {
  width: 500px;
  flex: 0 0 500px;
}
.clip {
  max-width: 1200px;
  margin: auto;
}
.form {
  position: relative;
  padding: 24px;
  min-height: 400px;
  border-radius: 4px;
}
.form .loading {
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background-color: rgba(255, 255, 255, 0.333);
  border-radius: 4px;
  z-index: 30;
}
.form h2 {
  font-size: 24px;
  color: #fff;
  text-align: center;
  margin-bottom: 24px;
  font-weight: 300;
  text-transform: uppercase;
}
.form .field {
  background-color: rgba(255, 255, 255, .9);
  margin-bottom: 18px;
  padding: 6px 12px;
  border-radius: 4px;
  position: relative;
}
.form .field input {
  width: 100%;
  background-color: transparent;
}
.form button {
  background-color: rgb(67, 115, 185);
  outline: none;
  width: 100%;
  padding: 12px 0;
  border-radius: 4px;
  color: #fff;
  font-weight: 300;
  font-size: 18px;
  margin-bottom: 12px;
}
.subbutton {
  color: #fff;
  text-align: center;
}
.subbutton a {
  color: rgb(112, 143, 199);
}

select {
  background-color: transparent;
}
.form .field-username {
  display: flex;
  padding-left: 0;
}
.field-username select {
  border-right: 1px solid rgba(0, 0, 0, .4);
  padding-right: 12px;
}
.field-username input {
  margin-left: 6px;
}

.form .vs__dropdown-toggle {
  border: 0;
}

.v-select {
  margin: 0;
  width: 200px;
  border-right: 1px solid rgba(0, 0, 0, .2);
  padding-left: 12px;
}
.v-select i.material-icons {
  width: 20px;
  height: 20px;
  font-size: 20px;
}
.map-section {
  height: 400px;
  position: relative;
  display: flex;
  align-items: center;
}
.map {
  position: absolute;
  top: 0;
  bottom: 0;
  left: 0;
  right: 0;
  z-index: 2;
}
.box {
  background-color: #fff;
  box-shadow: 0 2px 5px 2px rgba(0,0,0,.2);
  border-radius: 4px;
  padding: 24px;
  width: 250px;
  margin-left: calc((100% - 1200px)/2);
  z-index: 10;
}
@media screen and (max-width: 1200px) {
  .section {
    padding: 0 24px;
  }
  .box {
    margin-left: 0;
  }
}
@media screen and (max-width: 800px) {
  .main-section .clip {
    flex-direction: column;
    padding: 42px 0;
    height: auto;
  }
}
.logo-circle {
  display: flex;
  justify-content: center;
  align-items: center;
  background-color: #fff;
  border-radius: 50%;
  box-shadow: 1px 1px 10px 10px rgba(0, 0, 0, .2);
  width: 128px;
  height: 128px;
  margin-bottom: 24px;
}
.logo-circle img {
  display: block;
  max-width: 80px;
  max-height: 80px;
}
.info {
  margin-bottom: 24px;
}
.info:last-child {
  margin-bottom: 0;
}
.info_title {
  color: #7e7e7e;
  font-size: 12px;
  margin-bottom: 3px;
}
.info_content {
  color: #424242;
  font-weight: 400;
  white-space: pre-line;
}
.error {
  color: rgb(248, 79, 79);
  position: absolute;
  left: 0;
  top: 100%;
  font-size: 10px;
  line-height: 18px;
}
.welcome-block .welcome-box {
  width: 100%;
  padding: 24px;
  border-radius: 4px;
  display: flex;
  flex-direction: column;
}
.welcome-block .welcome-box .lk-button {
  display: block;
  padding: 12px 24px;
  border-radius: 4px;
  background-color: rgba(255,255,255,.1);
  color: #fff;
  text-transform: uppercase;
  text-align: center;
  margin-top: 36px;
  outline: 0;
  transition: all 300ms ease;
  text-decoration: none;
}
.welcome-block .welcome-box .lk-button:hover {
  background-color: rgba(255,255,255,.14);
}
.welcome-block .welcome-box .lk-button:active {
  transform: scale(0.98);
}
.welcome-block .title {
  color: #fff;
  font-size: 36px;
}
.reg-text {
  display: block;
  color: #424242;
  font-size: 24px;
  margin-bottom: 32px;
}
</style>